
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CompanyDetail extends Vue {
  @Prop({ type: String, default: '' })
  readonly coDetail!: string;
}
